(ns machtfit.product-form.where
  (:require [machtfit.dashboard-widgets :as widgets]
            [machtfit.product-form.core :as product-form]
            [machtfit.product-form.review :as review]
            [machtfit.product-form.section :refer [show-next-section] :as section]
            [machtfit.product-form.validation :as validation]
            [machtfit.utils :refer [scroll-down]]
            [re-frame.core :as rf]))

(rf/reg-event-db ::set-website
  (fn [db [_ new-website]]
    (-> db
        (assoc-in [:product :what :website] new-website)
        (assoc-in [:ui :last-focused-config-section] nil))))

(defn website [section]
  (let [online? (= :online @(rf/subscribe [:get [:product :where :location-type]]))]
    [:div.col.s12
     [widgets/block-input
      {:id (str "website-" (name section))
       :label-text (str "Webseite" (when-not online? " (falls vorhanden)"))
       :value @(rf/subscribe [:get [:product :what :website]])
       :on-change #(rf/dispatch [::set-website %])
       :block-style {:width "100%"}
       :style {:width "100%"}
       :validators [validation/website]
       :required? online?}]]))

(defn- is-stream []
  [:div.col.s12
   [:input.filled-in {:id "is-stream"
                      :type "checkbox"
                      :checked @(rf/subscribe [:get [:product :where :is-stream?]])
                      :on-change #(rf/dispatch [:toggle [:product :where :is-stream?]])}]
   [:label {:for "is-stream" :style {:color "black"}} "Angebot wird gestreamt"]])

(defn- is-app []
  [:div.col.s12
   [:input.filled-in {:id "is-app"
                      :type "checkbox"
                      :checked @(rf/subscribe [:get [:product :where :is-app?]])
                      :on-change #(rf/dispatch [:toggle [:product :where :is-app?]])}]
   [:label {:for "is-app" :style {:color "black"}} "Angebot ist eine App"]])

(defn- is-open-despite-corona []
  [:div.row>div.col.s12
   [:input.filled-in {:id "is-open-despite-corona"
                      :type "checkbox"
                      :checked @(rf/subscribe [:get [:product :where :is-open-despite-corona?]])
                      :on-change #(rf/dispatch [:toggle [:product :where :is-open-despite-corona?]])}]
   [:label {:for "is-open-despite-corona" :style {:color "black"}} "Wieder geöffnet?"]])

(defn- usage-description []
  (let [usage-description' @(rf/subscribe [:get [:product :where :usage-description]])]
    [:div.col.s12
     [widgets/textarea
      {:id "usage-description"
       :label-text "Nutzungsbeschreibung"
       :value usage-description'
       :on-save #(rf/dispatch [:set-path [:product :where :usage-description] %])}]
     (when (> (count usage-description') 1024)
       [:span>i {:style {:color "red"}}
        "Die Nutzungsbeschreibung ist zu lang. Es dürfen nur maximal 1024 Zeichen verwendet werden."])]))

(rf/reg-event-db ::set-location-type
  (fn [db [_ new-location-type]]
    (let [path [:product :where :location-type]]
      (-> db
          (assoc-in path new-location-type)
          (assoc-in [:ui :last-focused-config-section] :where)))))

(defn- location-type []
  (let [is-last-section? @(rf/subscribe [::section/is-last-visible-section? :where])]
    [:div.col.s12.valign-wrapper
     [widgets/choice
      {:name "location-type"
       :intro "Das Angebot"
       :choices {:fixed " findet an einem bestimmten Ort statt."
                 :online " findet online im Internet statt."
                 :none " ist ortsunabhängig."}
       :current-choice @(rf/subscribe [:get [:product :where :location-type]])
       :on-select #(do (rf/dispatch [::set-location-type %])
                       (when is-last-section? (scroll-down)))}]]))

(defn- location-type-ro []
  [:div
   [:div.col.s10 {:style {:margin-bottom "1.5rem"}}
    "Das Angebot "
    [:strong
     (case @(rf/subscribe [:get [:product :where :location-type]])
       :online "findet online im Internet statt."
       :fixed "findet an einem bestimmten Ort statt."
       :multiple "findet an mehreren physischen Orten statt. Nur durch das Entwicklerteam änderbar."
       :none "ist ortsunabhängig."
       "(unbekannt)")]]
   (when @(rf/subscribe [::product-form/meta-editable?])
     [:div.col.s2>p>a.btn {:on-click #(rf/dispatch [::section/focus-config-section :where])}
      "Ändern"])])

(rf/reg-event-db ::set-address-attribute
  (fn [db [_ attribute value]]
    (-> db
        (assoc-in [:product :where :address attribute] value)
        (assoc-in [:ui :last-focused-config-section] nil))))

(defn- blank->nil [s]
  (if (= "" s) nil s))

(defn- address-name []
  [widgets/block-input
   {:id "name"
    :label-text "Name (falls relevant)"
    :value @(rf/subscribe [:get [:product :where :address :name]])
    :on-change #(rf/dispatch [::set-address-attribute :name (blank->nil %)])
    :validators [(validation/max-length 255)]}])

(defn- address-street []
  [widgets/block-input
   {:id "street"
    :label-text "Straße und Hausnummer"
    :value @(rf/subscribe [:get [:product :where :address :street]])
    :on-change #(rf/dispatch [::set-address-attribute :street (blank->nil %)])
    :validators [(validation/max-length 255)]}])

(defn- address-extra []
  [widgets/block-input
   {:id "extra"
    :label-text "Zusatz (falls vorhanden)"
    :value @(rf/subscribe [:get [:product :where :address :extra]])
    :on-change #(rf/dispatch [::set-address-attribute :extra (blank->nil %)])
    :validators [(validation/max-length 255)]}])

(defn- address-postcode []
  [widgets/block-input
   {:id "postcode"
    :label-text "Postleitzahl"
    :value @(rf/subscribe [:get [:product :where :address :postcode]])
    :on-change #(rf/dispatch [::set-address-attribute :postcode (blank->nil %)])
    :validators [(validation/max-length 64)]}])

(defn- address-city []
  [widgets/block-input
   {:id "city"
    :label-text "Ort"
    :value @(rf/subscribe [:get [:product :where :address :city]])
    :on-change #(rf/dispatch [::set-address-attribute :city (blank->nil %)])
    :validators [(validation/max-length 255)]}])

(defn- address-country []
  [:div.input-field
   [:label.active {:style {:padding-bottom "0.4rem" :margin-top "0.2rem"}} "Land"]
   [widgets/select-box
    {:value @(rf/subscribe [:get [:product :where :address :country]])
     :on-change #(rf/dispatch [::set-address-attribute :country %])
     :data (cond-> ["Deutschland"]
             (not @(rf/subscribe [:get [:options :partner-product?]])) (conj "Österreich"))
     :no-widget-init? true
     :browser-default? true}]])

(defn- address-input []
  [:div.row
   [:div>div.col.s4 [address-name]]
   [:div {:style {:clear "both"}}
    [:div.col.s4 [address-street]]
    [:div.col.s3 [address-extra]]]
   [:div {:style {:clear "both" :margin-bottom "1rem"}}
    [:div.col.s1 [address-postcode]]
    [:div.col.s3 [address-city]]]
   [:div {:style {:clear "both" :margin-bottom "1rem"}}
    [:div.col.s3 [address-country]]]])

(defn section-where []
  (let [current-location-type @(rf/subscribe [:get [:product :where :location-type]])
        config-active? @(rf/subscribe [::section/section-configuration-active? :where])
        online? (= :online current-location-type)]
    [widgets/section {:anchor "where"
                      :title [review/highlighted-section-title :where "Wo"]
                      :subtitle [:div "findet das Angebot statt?"
                                 [review/field-badges :where]]
                      :content [:div
                                (if config-active?
                                  [location-type]
                                  [location-type-ro])

                                (case current-location-type
                                  :online [website :where]
                                  :fixed [:<>
                                          [address-input]
                                          (when @(rf/subscribe [::product-form/machtfit-admin?])
                                            [is-open-despite-corona])]
                                  :none [is-app]
                                  nil)

                                (when online?
                                  [:<>
                                   [is-stream]
                                   [is-app]
                                   [usage-description]])

                                (when (some? current-location-type)
                                  [show-next-section :where])]}]))
